import type { TUtils } from "@monta/utils";
import CartIcon from "../shared/cartIcon/CartIcon";
import styles from "./beforLogin.module.scss";
import LoginButton from "./loginButton/LoginButton";

export interface BeforeLoginProps {
  cart: TUtils["cart"];
}

const BeforLogin = (props: BeforeLoginProps) => {
  const { cart } = props;

  return (
    <div className={styles["befor-login"]}>
      <CartIcon cart={cart} />
      <LoginButton />
    </div>
  );
};

export default BeforLogin;
